import React from 'react';

interface Props {
  country: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
}

export const CompanyRegistrationInput: React.FC<Props> = ({
  country,
  value,
  onChange,
  error,
  required = false,
}) => {
  const isFrance = country === 'France';
  const isCountrySelected = Boolean(country);

  const validate = (val: string) => {
    if (!required && !val) return true;
    if (!isCountrySelected) return true;
    if (isFrance) return /^[0-9]{14}$/.test(val);
    return /^[A-Za-z0-9\-]{4,}$/.test(val);
  };

  const isValid = validate(value);

  const placeholder = isFrance
    ? '14-digit SIRET number'
    : 'Company registration number';

  const label = isFrance ? 'SIRET Number' : 'Registration Number';

  return (
    <div>
      <label className="form-label">{isCountrySelected ? label : 'Registration Number'}</label>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required && isCountrySelected}
        disabled={!isCountrySelected}
        className={`form-input ${
          !isValid && value ? 'border-red-300 focus:border-red-500' : ''
        } ${!isCountrySelected ? 'bg-gray-100 cursor-not-allowed' : ''}`}
        pattern={isFrance ? '[0-9]{14}' : undefined}
      />
      {!isValid && value && isCountrySelected && (
        <p className="mt-1 text-sm text-red-600">
          {isFrance
            ? 'SIRET must be exactly 14 digits'
            : 'Invalid registration number format'}
        </p>
      )}
      {!isCountrySelected && (
        <p className="mt-1 text-sm text-gray-500">
          Please select a country first
        </p>
      )}
    </div>
  );
};